import { Divider } from "@mui/material";
import { SimpleShowLayout as RASimpleShowLayout } from "react-admin";

export const SimpleShowLayout = ({ children, ...props }) => (
  <RASimpleShowLayout divider={<Divider flexItem />} {...props}>
    {children}
  </RASimpleShowLayout>
);
